import React, { createContext, useContext, useState } from "react";
import { IBannerData, IMemberBannerContext } from "../exports/interfaces";

const MemberBannerContext = createContext<IMemberBannerContext>({
  memberBannerData: [],
  setMemberBannerData: () => null,
});
export const useMemberBannerContext = () => useContext(MemberBannerContext);

export const MemberBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [memberBannerData, setMemberBannerData] = useState<IBannerData[]>([]);

  return (
    <MemberBannerContext.Provider value={{ memberBannerData, setMemberBannerData }}>
      {children}
    </MemberBannerContext.Provider>
  );
};